import { ReactComponent as Emoji_1f389 } from 'assets/icons/emojis/Emoji_1f389.svg';
import { ReactComponent as Emoji_1f440 } from 'assets/icons/emojis/Emoji_1f440.svg';
import { ReactComponent as Emoji_1f44d } from 'assets/icons/emojis/Emoji_1f44d.svg';
import { ReactComponent as Emoji_1f44e } from 'assets/icons/emojis/Emoji_1f44e.svg';
import { ReactComponent as Emoji_1f44f } from 'assets/icons/emojis/Emoji_1f44f.svg';
import { ReactComponent as Emoji_1f480 } from 'assets/icons/emojis/Emoji_1f480.svg';
import { ReactComponent as Emoji_1f525 } from 'assets/icons/emojis/Emoji_1f525.svg';
import { ReactComponent as Emoji_1f602 } from 'assets/icons/emojis/Emoji_1f602.svg';
import { ReactComponent as Emoji_1f605 } from 'assets/icons/emojis/Emoji_1f605.svg';
import { ReactComponent as Emoji_1f60d } from 'assets/icons/emojis/Emoji_1f60d.svg';
import { ReactComponent as Emoji_1f621 } from 'assets/icons/emojis/Emoji_1f621.svg';
import { ReactComponent as Emoji_1f62e } from 'assets/icons/emojis/Emoji_1f62e.svg';
import { ReactComponent as Emoji_1f64c } from 'assets/icons/emojis/Emoji_1f64c.svg';
import { ReactComponent as Emoji_1f64f } from 'assets/icons/emojis/Emoji_1f64f.svg';
import { ReactComponent as Emoji_1f914 } from 'assets/icons/emojis/Emoji_1f914.svg';
import { ReactComponent as Emoji_2764 } from 'assets/icons/emojis/Emoji_2764.svg';

export const emojis = [
  { id: '1f44d', Emoji: Emoji_1f44d }, // Thumbs up
  { id: '1f44e', Emoji: Emoji_1f44e }, // Thumbs down
  { id: '1f525', Emoji: Emoji_1f525 }, // Fire
  { id: '1f389', Emoji: Emoji_1f389 }, // Party popper
  { id: '2764', Emoji: Emoji_2764 }, // Heart
  { id: '1f60d', Emoji: Emoji_1f60d }, // Heart eyes
  { id: '1f44f', Emoji: Emoji_1f44f }, // Clapping hands
  { id: '1f64c', Emoji: Emoji_1f64c }, // Raised hands
  { id: '1f64f', Emoji: Emoji_1f64f }, // Folded hands
  { id: '1f914', Emoji: Emoji_1f914 }, // Thinking face
  { id: '1f602', Emoji: Emoji_1f602 }, // Crying laugh
  { id: '1f605', Emoji: Emoji_1f605 }, // Smiling with sweat
  { id: '1f440', Emoji: Emoji_1f440 }, // Eyes
  { id: '1f62e', Emoji: Emoji_1f62e }, // Face with open mouth
  { id: '1f621', Emoji: Emoji_1f621 }, // Angry face
  { id: '1f480', Emoji: Emoji_1f480 }, // Skull
];
